module.exports = __webpack_public_path__ + "static/media/A7S01346.a5a7b32f.jpg";